<li [ngClass]="{ selected: item.selected, closed: item.closed, new: item.isNew }">
  <a *ngIf="!(item.type === 'RECORD' || item.type === 'DATA')" class="toggle clickable" (click)="toggle()">
    <t-icon *ngIf="!item.closed" name="remove_circle_outline"></t-icon>
    <t-icon *ngIf="item.closed" name="add_circle_outline"></t-icon>
  </a>

  <a *ngIf="item.type === 'RECORD' || item.type === 'DATA'" class="toggle">
    <t-icon name="insert_drive_file"></t-icon>
  </a>

  <a class="text" [ngClass]="{ clickable: item.canSelect }" (click)="onSelect()">
    <span *ngIf="!item.isNew">{{ item.label }}</span>
    <span *ngIf="item.isNew">[Nouveau]</span>
  </a>

  <!-- Simple item -->
  <ng-container *ngIf="item.type === 'SIMPLE_WITH_GROUPS' || item.type === 'SIMPLE'">
    <a *ngIf="item.canRetract" class="action action_2 clickable" (click)="toggleExpand()" title="Afficher un seul groupe">
      <t-icon name="unfold_less"></t-icon>
    </a>
    <a *ngIf="item.canExpand" class="action action_2 clickable" (click)="toggleExpand()" title="Afficher tout les groupes">
      <t-icon name="unfold_more"></t-icon>
    </a>

    <a *ngIf="(item.canExpand || item.type === 'SIMPLE') && !item.isReadOnly" class="action clickable" (click)="onAdd()" title="Ajouter un enregistrement">
      <t-icon name="add"></t-icon>
    </a>
    <a *ngIf="item.canRetract && !item.isReadOnly" class="action clickable" (click)="onAddGroup()" title="Ajouter un groupe">
      <t-icon name="create_new_folder"></t-icon>
    </a>

    <div *ngIf="item.canExpand" class="group">
      <a *ngIf="!item.isReadOnly" class="action clickable" (click)="onDuplicateGroup()" title="Dupliquer le groupe">
        <t-icon name="content_copy"></t-icon>
      </a>
      <a *ngIf="!item.isReadOnly" class="action clickable" (click)="onAddGroup()" title="Ajouter un groupe">
        <t-icon name="create_new_folder"></t-icon>
      </a>
      <select [(ngModel)]="item.selectedGroup">
        <option *ngFor="let group of item.groups" [ngValue]="group">{{group.label}}</option>
      </select>
    </div>
  </ng-container>

  <!-- Simple With Groups but there are no groups -->
  <ng-container *ngIf="item.type === 'SIMPLE_WITH_GROUPS' && !item.hasGroups && !item.isReadOnly">
    <a class="action clickable" (click)="onAddGroup()" title="Ajouter un groupe">
      <t-icon name="create_new_folder"></t-icon>
    </a>
  </ng-container>

  <!-- Group item -->
  <ng-container *ngIf="item.type === 'GROUP' && !item.isNew && !item.isReadOnly">

    <a class="action clickable" (click)="onAdd()" title="Ajouter un enregistrement">
      <t-icon name="add"></t-icon>
    </a>
    <a class="action action_2 clickable" (click)="onDeleteGroup()" title="Supprimer le groupe">
      <t-icon name="delete_sweep"></t-icon>
    </a>

    <a class="action action_3 clickable" (click)="onDuplicateGroup()" title="Dupliquer le groupe">
      <t-icon name="content_copy"></t-icon>
    </a>

    <a class="action action_4 clickable" *ngIf="item.canMoveGroupUp" (click)="onMoveGroupUp()" title="Déplacer le groupe vers le haut">
      <t-icon name="arrow_upward"></t-icon>
    </a>

    <a class="action action_5 clickable" *ngIf="item.canMoveGroupDown" (click)="onMoveGroupDown()" title="Déplacer le groupe vers le bas">
      <t-icon name="arrow_downward"></t-icon>
    </a>

  </ng-container>

  <!-- Record/Data -->
  <a *ngIf="(item.type === 'RECORD' || item.type === 'DATA') && !item.isNew && !item.isReadOnly" class="action clickable " (click)="onDelete()"
    title="Supprimer ">
    <t-icon name="delete"></t-icon>
  </a>

  <ul>
    <ng-container *ngFor="let child of item.children">
      <t-dossier-tree-item [item]="child" [treeComponent]="treeComponent"></t-dossier-tree-item>
    </ng-container>
  </ul>
</li>
